module.exports = __webpack_public_path__ + "img/gift_dot.c16c15b1.png";